import { useIsAuthenticated } from '@azure/msal-react';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import { styled } from '@material-ui/core/styles';
import { default as React, type ComponentType, type FC } from 'react';

const LoadingBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100vh',
});

export const withAuth = (Component: ComponentType): FC =>
  function WithAuth(props) {
    return useIsAuthenticated() ? (
      <Component {...props} />
    ) : (
      <LoadingBox>
        <LinearProgress />
        <br />
        Authenticating...
      </LoadingBox>
    );
  };
